export default {
  'moduleTitle.address': '',
  'moduleTitle.address_details': '',
  'moduleTitle.activity_details': '',
  'moduleTitle.add_log': '',
  'moduleTitle.award_level': '',
  'moduleTitle.adventurous_journey': '',
  'moduleTitle.already_assessed': '',
  'moduleTitle.approved': '',
  'moduleTitle.assessor_details': '',
  'moduleTitle.authorising_contact_license_holder': '',
  'moduleTitle.category_journey_details': '',
  'moduleTitle.complete_report': '',
  'moduleTitle.completed_progress': '',
  'moduleTitle.congratulation': '',
  'moduleTitle.confirming_email_address': '',
  'moduleTitle.contact_details': '',
  'moduleTitle.edit_log': '',
  'moduleTitle.event_journey': '',
  'moduleTitle.forgotten_password': '',
  'moduleTitle.great_you_are_almost_there': '',
  'moduleTitle.home_address': '',
  'moduleTitle.journey_overview': '',
  'moduleTitle.log_detail': '',
  'moduleTitle.login': '',
  'moduleTitle.new_activity': '',
  'moduleTitle.new_event_journey': '',
  'moduleTitle.new_residential_project': '',
  'moduleTitle.notRegistred': '',
  'moduleTitle.nominated_award_leader_contact_details': '',
  'moduleTitle.nominated_award_leader': '',
  'moduleTitle.organisation_address': '',
  'moduleTitle.organisation_details': '',
  'moduleTitle.online_record_book_account': '',
  'moduleTitle.page_not_found': '',
  'moduleTitle.personal_details': '',
  'moduleTitle.preparation_and_training': '',
  'moduleTitle.profile_guardian_consent': '',
  'moduleTitle.profile_questions': '',
  'moduleTitle.registration_for_level': '',
  'moduleTitle.residential_project': '',
  'moduleTitle.residential_project_details': '',
  'moduleTitle.reset_password': '',
  'moduleTitle.welcome_to_the_orb': '',
  'moduleTitle.we_have_sent_you_an_email': '',
  'moduleTitle.your_registration_is_complete': '',
  'formTitle.activity_details': '',
  'formTitle.assessor_details': '',
  'formTitle.supervisors_details': '',
  'formTitle.preparation_and_training_activities': '',
  'formTitle.added_preparation_activities': '',
  'label.add_picture': '',
  'label.address_first_line': '',
  'label.address_second_line': '',
  'label.are_you_already_running_award': '',
  'label.are_you_the_main_award_leader': '',
  'label.award_participant': '',
  'label.award_leader': '',
  'label.birthdate': '',
  'label.category': '',
  'label.change_locale': '',
  'label.choose_project': '',
  'label.city': '',
  'label.choose_as_major_activity': '',
  'label.date': '',
  'label.date_of_birth': '',
  'label.description_of_progress': '',
  'label.duration': '',
  'label.email': '',
  'label.email_address': '',
  'label.email_again': '',
  'label.employment_status': '',
  'label.end_date': '',
  'label.enter_his_email': '',
  'label.entered_transaction_id': '',
  'label.first_name': '',
  'label.gender': '',
  'label.goal': '',
  'label.journey_activity': '',
  'label.journey_objective': '',
  'label.journey_observations': '',
  'label.journey_type': '',
  'label.last_name': '',
  'label.level': '',
  'label.location': '',
  'label.logout': '',
  'label.major': '',
  'label.middle_name': '',
  'label.mode_of_transport': '',
  'label.my_award_leader': '',
  'label.name': '',
  'label.nationality': '',
  'label.no': '',
  'label.no_results': '',
  'label.note': '',
  'label.note_for_assessor': '',
  'label.note_for_leader': '',
  'label.optional': '',
  'label.organisation_name': '',
  'label.organisation_type': '',
  'label.others': '',
  'label.password': '',
  'label.password_again': '',
  'label.project_location': '',
  'label.pay_online': '',
  'label.pay_award_leader_or_unit': '',
  'label.payment_not_required': '',
  'label.payment_type': '',
  'label.phone': '',
  'label.phone_number': '',
  'label.phone_type': '',
  'label.profile': '',
  'label.reset_password': '',
  'label.region': '',
  'label.relationship': '',
  'label.role_in_organisation': '',
  'label.select_country': '',
  'label.select_your_au': '',
  'label.start_typing': '',
  'label.start_date': '',
  'label.select': '',
  'label.select_async': '',
  'label.select_your_operating_authority': '',
  'label.specify_category': '',
  'label.subcategory': '',
  'label.title': '',
  'label.username': '',
  'label.what_is_your_role': '',
  'label.where_have_you_completed': '',
  'label.yes': '',
  'label.your_changes_havent_been_saved': '',
  'label.zip': '',
  'label.adventurous_journey': '',
  'label.after_your_journey_describe': '',
  'label.because_your_age_is_under_18': '',
  'label.before_you_head_to_journey': '',
  'label.before_entering_new_level': '',
  'label.bring_required_amount_to_your_award_leader': '',
  'label.do_you_have_any_other_level': '',
  'label.do_you_know_who_is_your_award_leader': '',
  'label.going_on_an_expedition': '',
  'label.going_on_residential_gives_chance': '',
  'label.i_confirm_that_i_meet': '',
  'label.i_agree_to_volunteer_code': '',
  'label.i_have_read_the_terms_and_conditions': '',
  'label.i_will_bring_the_consent_to_my_award_leader_later': '',
  'label.if_you_are_from_orphanage': '',
  'label.here_you_can_add_activity': '',
  'label.how_do_you_want_to_apply': '',
  'label.my_parent_consent_has_been_already_given': '',
  'label.my_parent_will_confirm_consent_by_email': '',
  'label.major_activity_means_that_you_have_to_spent': '',
  'label.not_sure_about_your_auth': '',
  'label.page_not_found': '',
  'label.please_fill_in_the_following': '',
  'label.register_a_new_account_as': '',
  'label.residential_project': '',
  'label.select_your_award_unit': '',
  'label.the_expedition_can_be_faraway': '',
  'label.to_log_your_process_on_orb': '',
  'label.waiting_for_assessment': '',
  'label.waiting_for_sign_off': '',
  'label.we_have_sent_you_an_email': '',
  'label.what_level_of_the_award': '',
  'label.you_are_now_registering_as_participant': '',
  'label.you_are_now_registering_as_award_unit': '',
  'label.you_can_use_my_photos_for_promotional_purposes': '',
  'label.you_can_send_activity_for_approval': '',
  'label.you_can_send_activity_for_leader': '',
  'label.you_can_send_residential_project_to_leader': '',
  'label.you_have_finished_now_send_to_approval': '',
  'label.preparation_and_training': '',
  'label.you_will_be_redirected_to_the_payment': '',
  'label.you_will_be_the_first_award_leader': '',
  'label.youll_receive_a_notification': '',
  'label.your_parent_email': '',
  'label.your_parent_first_name': '',
  'label.your_parent_last_name': '',
  'label.your_report_approve_now_send_to_leader': '',
  'label.there_are_loads_of_exciting_possibilities': '',
  'label.your_residential_project_has_been_setup': '',
  'label.your_report_has_been_sent_assessor': '',
  'label.your_report_has_been_sent_leader': '',
  'label.your_residential_project_is_complete': '',
  'label.to_work_on_the_online': '',
  'label.we_will_send_you_an_email': '',
  'label.if_you_have_any_problems_or_doubts': '',
  'label.are_you_sure_you_want_to_leave': '',
  'label.no_logs_yet': '',
  'label.menu': '',
  'notifications.award_unit_has_been_created': '',
  'notifications.authorization_code_is_not_valid': '',
  'notifications.email_has_been_confirmed': '',
  'notifications.leader_has_been_created': '',
  'notifications.participant_has_been_created': '',
  'notifications.email_with_instructions_has_been_sent': '',
  'notifications.your_new_password_has_been_set': '',
  'notifications.success': '',
  'notifications.unknown_role': '',
  'notifications.waiting_for_approval': '',
  'notifications.activity_cannot_be_created': '',
  'notifications.new_activity_has_been_added': '',
  'notifications.new_log_has_been_added': '',
  'notifications.log_has_been_deleted': '',
  'notifications.log_has_been_modified': '',
  'notifications.adventurous_journey_cannot_be_created_until_approved': '',
  'notifications.new_participant_event_has_been_added': '',
  'notifications.participant_event_has_been_completed': '',
  'notifications.training_and_practice_modified': '',
  'notifications.completion_residential_project_completed': '',
  'notifications.new_residential_project_has_been_added': '',
  'notifications.residential_project_cannot_be_created_until_approved': '',
  'notifications.already_assessed_sent': '',
  'notifications.assessment_request_sent': '',
  'notifications.leader_approval_sent': '',
  'tabs.logs': '',
  'tabs.new': '',
  'tabs.overview': '',
  'tabs.report': '',
  'button.add_activity': '',
  'button.add_log': '',
  'button.continue_here': '',
  'button.continue': '',
  'button.continue_to_award': '',
  'button.delete': '',
  'button.edit': '',
  'button.edit_log': '',
  'button.finish': '',
  'button.forgot_your_password': '',
  'button.i_already_have_assessment': '',
  'button.leave_anyway': '',
  'button.login': '',
  'button.no': '',
  'button.register': '',
  'button.send': '',
  'button.send_for_approval': '',
  'button.setup': '',
  'button.setup_residential': '',
  'button.stay': '',
  'button.submit': '',
  'button.update': '',
  'button.yes': '',
  'errors.at_least_num_characters': '',
  'errors.do_not_match': '',
  'errors.include_at_least_one_number': '',
  'errors.include_both_lower_and_upper_case': '',
  'errors.invalid_phone_format': '',
  'errors.invalid_email_address': '',
  'errors.required_field': '',
  'errors.must_be_at_least': '',
  'errors.must_be_no_more_than': '',
  'errors.must_be_an_integer': '',
  'errors.must_contain_at_least': '',
  'errors.must_include_at_least': '',
  'errors.must_be_one_of': '',
  'errors.you_must_be_younger_than': '',
  'errors.you_must_be_older_than': '',
  'errors.email_address_is_in_use_please_sign': '',
  'errors.email_address_is_in_use': '',
  'errors.sorry_we_already_have_this_email': '',
  'wizard.authorising_contact': '',
  'wizard.award_leader_contact': '',
  'wizard.award_unit_details': '',
  'wizard.contact_details': '',
  'wizard.contacts': '',
  'wizard.level': '',
  'wizard.level_selection': '',
  'wizard.leader_details': '',
  'wizard.nominated_award_leader': '',
  'wizard.orb_account': '',
  'wizard.parent_consent': '',
  'wizard.participant_details': '',
  'wizard.profile': '',
  'wizard.payment': '',
  'wizard.select_award_unit': '',
  'wizard.unit_details': '',
  'wizard.welcome': '',
  'wizard.your_details': '',
  'awardUnit.do_you_want_to_create': '',
  'parent.you_can_download_the_consent_here': '',
  'footer.copyright': '',
  'registration_participant.required_award_payment': '',
  'registration_participant.pay_online_here': '',
  'dashboard.activity_log_time': '',
  'moduleTitle.award_completed': '',
  'notifications.award_approval_request_sent_to_leader': '',
  'notifications.new_participant_event_has_been_completed': '',
  'notifications.preparation_and_training_approval_sent': '',
  'notifications.reparation_and_training_completed': '',
  'notifications.your_profile_photo_has_been_edited': '',
  'notifications.your_profile_has_been_edited': '',
  'notifications.new_level_has_started': '',
  'notifications.activity_has_been_edited': '',
  'notifications.you_have_been_logged_out': '',
  'notifications.logging_out': '',
  'label.you_can_send_award_to_leader': '',
  'label.you_have_completed_all_sections_of_your_award': '',
  'label.you_have_now_completed_your_award': '',
  'label.congratulation_your_award_has_been_approved': '',
  'moduleTitle.settings': '',
  'moduleTitle.edit_activity': '',
  'moduleTitle.select_your_major_activity': '',
  'label.settings': '',
  'label.major_activity_means_that_you_will': '',
  'label.notifications': '',
  'label.my_award': '',
  'label.physical_recreation': '',
  'label.skill': '',
  'label.service': '',
  'label.my_parent_will_complete_and_sign_form': '',
  'label.please_print_it_tak_it_to_your_parent': '',
  'label.change_password': '',
  'label.change_major_activity': '',
  'title.change_password': '',
  'label.old_again': '',
  'label.new_password': '',
  'label.new_password_again': '',
  'errors.passwords_dont_match': '',
  'errors.more_than': '',
  'button.parent_guardian_consent_pdf': '',
  'button.send_award_for_approval': '',
  'button.send_report': '',
  'button.terms_and_conditions': '',
  'button.privacy_policy': '',
  'button.save': '',
  'button.start_new_level': '',
  'button.change_password': '',
  'button.edit_activity': '',
  'moduleTitle.file_upload': '',
  'label.add_file': '',
  'label.description': '',
  'label.waiting_for_office_sign_off': '',
  'notifications.file_has_been_uploaded': '',
  'tabs.files': '',
  'button.upload': '',
  'button.upload_file': '',
  'button.add_file': '',
  'button.this_activity_has_no_assessor': '',
  'label.i_want_to_register_my_award': '',
  'label.select_sub_operating_authority': '',
  'label.your_must_first_setup_some_activity': '',
  'label.you_cant_change_your_major_activity': '',
  'label.s_specific': '',
  'label.m_measurable': '',
  'label.a_achievable': '',
  'label.r_realistic': '',
  'label.t_timely': '',
  'label.you_can_upload_here_any_files': '',
  'moduleTitle.login_change': '',
  'notifications.adventurous_journey_modified': '',
  'tabs.sections': '',
  'label.change_email': '',
  'title.change_email': '',
  'label.new_email': '',
  'label.new_email_again': '',
  'errors.emails_dont_match': '',
  'button.change_email': '',
  'notifications.email_with_instructions_has_been_sent_to_your_inbox': '',
  'global.dofe_name': '',
  'global.or': '',
  'route.landing_page': '',
  'route.dashboard': '',
  'moduleTitle.notifications': '',
  'moduleTitle.no_notifications': '',
  'moduleTitle.new_notifications': '',
  'moduleTitle.older_notifications': '',
  'moduleTitle.user_guide': '',
  'label.user_guide': '',
  'notifications.your_password_has_been_changed': '',
  'label.country': '',
  'label.on_your_smartphone': '',
  'label.on_the_web': '',
  'label.orb_online': '',
  'label.language': '',
  'moduleTitle.participant_login': '',
  'label.for_ios': '',
  'label.for_android': '',
  'button.login_as_award_staff': '',
  'errors.leader_doesnt_exist': '',
  'global.loading': '',
  'moduleTitle.award_staff_login': '',
  'formTitle.residential_project_details': '',
  'label.you_can_also_download_participant': '',
  'label.you_can_also_download_leader': '',
  'notifications.this_role_is_not': '',
  'notifications.residential_project_has_been_updated': '',
  'tabs.participant': '',
  'tabs.award_staff': '',
  'moduleTitle.edit_residential_project': '',
  'button.residential_project': '',
  'notifications.your_login_email_has_been_changed': '',
  'meta.dofe_name': '',
  'notifications.unknown_role_leader': '',
  'notifications.unknown_role_participant': '',
  'label.user_guide_web_participant': '',
  'label.user_guide_app_participant': '',
  'label.note_for_supervisor': '',
  'label.before_submitting_your_aj': '',
  'button.back_to_home': '',
  'moduleTitle.assessor_approval': '',
  'label.this_aj_has_no_assessor': '',
  'route.not_found': '',
  'notifications.are_you_sure': '',
  'button.cancel': '',
  'label.add_document': '',
  'errors.there_are_currently_no_details_for_your': '',
  'moduleTitle.missing_data': '',
  'label.to_send_assessment_request': '',
  'label.pending_changes': '',
  'label.some_fields_require': '',
  'roles.assessor': '',
  'roles.supervisor': '',
  'pageTitle.register_participant': '',
  'moduleTitle.revise_message': '',
  'moduleTitle.payment_for_level': '',
  'moduleTitle.payment': '',
  'moduleTitle.we_have_sent_you_payment_link': '',
  'label.required_award_payment': '',
  'label.payment_fees': '',
  'label.payment_method': '',
  'label.you_will_type_trans_id': '',
  'label.any_level_previously': '',
  'label.registering_for_level': '',
  'notification.payment_link_expired': '',
  'button.pay': '',
  'label.registration_updated': '',
  'label.award_leader_receive_payment': '',
  'errors.end_date_after': '',
  'button.back': '',
  'button.edit_info': '',
  'moduleTitle.level_detail': '',
  'label.payment_methods': '',
  'label.address': '',
  'note.review_filled_participant': '',
  'moduleTitle.payment_successful': '',
  'button.proceed_to_login': '',
  'label.add_additional_activity': '',
  'moduleTitle.welcome_to_orb': '',
  'empty_dashboard.not_approved': '',
  'empty_dashboard.approved_1': '',
  'empty_dashboard.approved_2': '',
  'label.discuss_activity_leader': '',
  'label.cannot_add_activity': '',
  'button.ok': '',
  'label.payment_was_canceled': '',
  'label.problem_with_payment': '',
  'pageTitle.register_leader': '',
  'pageTitle.registration_complete': '',
  'label.payment_link_expired_or_paid': '',
  'label.contact_nao_assistance': '',
  'label.send_required_amount_to_your_award_leader': '',
  'label.fee_can_be_paid': '',
  'notifications.login_failed_right_tab': '',
  'label.i_have_read_privacy_policy': '',
  'errors.invalid_date_format': '',
  'label.no_privacy_policy': '',
  'label.status': '',
  'moduleTitle.attached_with_observation': '',
  'moduleTitle.revise_message_rp': '',
  'file.activity_section_summary': '',
  'label.download_section_summary': '',
  'label.award_summary': '',
  'btn.download_summary_for_assessor': '',
  'label.first_activity_started': '',
  'label.hours_completed_required': '',
  'label.weeks_completed_required': '',
  back_to_home: '',
  'label.activity_rejected_click': '',
  'button.more_information': '',
  'label.attached_file': '',
  'moduleTitle.journey_details': '',
  'tabs.activity': '',
  'label.confirm_email': '',
  'label.aj_rejected_click': '',
  'label.verifying_payment': '',
  'button.finish_and_pay': '',
  'label.payment_not_successful_text': '',
  'label.payment_not_completed': '',
  'button.pay_now': '',
  'label.registration_pending_parental_consent': '',
  'button.edit_observation': '',
  'moduleTitle.qualifying': '',
  'moduleTitle.practice': '',
  'label.first_log_entry': '',
  'label.first_log_entry_date': '',
  'label.last_log_entry': '',
  'label.last_log_entry_date': '',
  'label.you_can_send_journey_report_for_approval': '',
  'button.edit_and_resend_report': '',
  'label.your_journey_is_complete': '',
  'button.add_additional_journey': '',
  'moduleTitle.edit_journey': '',
  'notifications.assessment_sent': '',
  'notifications.file_is_too_big': ''
}
